
import vClickOutside from 'v-click-outside'
import languages from '@/static/data/languages.json'

const languageListSorted = Object.entries(languages)
  .map(([key, lang]) => ({ key, name: lang.name }))
  .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))

let currencyDisplayNames = null
if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
  try {
    currencyDisplayNames = new Intl.DisplayNames(['en'], { type: 'currency' })
  } catch (_) {}
}

function currencyName (code) {
  try {
    return (currencyDisplayNames && currencyDisplayNames.of(code)) || code
  } catch (_) {
    return code
  }
}

function currencyCountryCode (code) {
  if (code === 'EUR') return 'eu'
  // ISO 4217 fiat codes start with a 2-letter country code
  if (/^[A-Z]{3}$/.test(code)) return code.slice(0, 2).toLowerCase()
  return null
}

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    defaultTab: {
      type: String,
      default: 'language',
      validator: v => ['language', 'currency'].includes(v)
    }
  },
  data () {
    return {
      activeTab: this.defaultTab,
      pendingLanguage: this.$i18n.locale,
      pendingCurrency: this.$store.state.destinationCurrency,
      languageListSorted,
      currencySearch: '',
      clipUid: `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`
    }
  },
  computed: {
    isHotel () {
      return this.$store.state.siteType === 'hotels'
    },
    currenciesLoaded () {
      return this.$store.state.currenciesLoaded
    },
    allCurrencyEntries () {
      return Object.keys(this.$store.state.currenciesByCode)
        .sort()
        .map(code => ({
          code,
          name: currencyName(code),
          countryCode: currencyCountryCode(code)
        }))
    },
    filteredCurrencyEntries () {
      const q = this.currencySearch.trim().toLowerCase()
      if (!q) return this.allCurrencyEntries
      return this.allCurrencyEntries.filter(entry =>
        entry.code.toLowerCase().includes(q) ||
        entry.name.toLowerCase().includes(q)
      )
    }
  },
  methods: {
    switchTab (tab) {
      this.activeTab = tab
      this.currencySearch = ''
    },
    close () {
      this.$emit('close')
    },
    confirm () {
      this.$emit('confirm', { language: this.pendingLanguage, currency: this.pendingCurrency })
    },
    hideFlagOnError (event) {
      event.target.style.display = 'none'
    }
  }
}
